import axios from 'axios-observable';
import { UserToken, UserCredentials, OauthTokenResponse } from './models';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import CONFIG from '../../settings';
import { createBasicAuthHeader } from './auth.functions';

const authUrl = `${CONFIG.apiUrl}:${CONFIG.basePort}/oauth/token`;

export const kAuth = (userCredentials: UserCredentials): AxiosObservable<UserToken> => {
  const params = new URLSearchParams();

  params.append('username', userCredentials.username);
  params.append('password', userCredentials.password);
  params.append('grant_type', 'password');

  return axios.post<UserToken>(`${authUrl}`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic cHJvdGVjdG9yOnBhc3NvbGFyZ28='
    }
  });
};

export const kRefreshToken = (refreshToken: string): AxiosObservable<UserToken> => {
  const params = new URLSearchParams();

  params.append('refresh_token', refreshToken);
  params.append('grant_type', 'refresh_token');

  return axios.post<UserToken>(`${authUrl}`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Basic cHJvdGVjdG9yOnBhc3NvbGFyZ28='
    }
  });
};

export const requestAccessToken = (code: string) => {
  const data = new FormData();
  const client_id = CONFIG.oauthClientID as string;
  data.set('code', code);
  data.set('client_id', client_id);
  data.set('grant_type', 'authorization_code');
  data.set('redirect_uri', `${globalThis.location.origin}/signin`);

  const basicAuth = createBasicAuthHeader();

  return axios.post<OauthTokenResponse>(`${CONFIG.coreServicesApiUrl}/oauth/token`, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: `Basic ${basicAuth}`
    }
  });
};

export const refreshToken = (token: string): AxiosObservable<OauthTokenResponse> => {
  const basicAuth = createBasicAuthHeader();
  const callApi = axios.post<OauthTokenResponse>(
    `${CONFIG.coreServicesApiUrl}/oauth/token?grant_type=refresh_token&refresh_token=${token}`,
    null,
    {
      headers: {
        Authorization: `Basic ${basicAuth}`
      }
    }
  );
  return callApi;
};
